import React from "react";
import { observer } from "mobx-react";
import { useStores } from "../hooks/useStores";
import { useTranslation } from "react-i18next";
import starB from "../assets/img/cards/FAVORITOS_B.svg";
import Timetables from "../components/Timetables";
import FavLines from "../components/FavLines";
import FavStops from "../components/FavStops";

const Favorites = observer(() => {
  const { t } = useTranslation();
  const { myTibStore } = useStores();
  const {
    favLines,
    favStops,
    allLines,
    allStops,
    loadingLines,
    loadingStops,
  } = myTibStore;

  return (
    <div>
      <div className="page-title-mobile">
        {t("my_favs").replace("/", " ")}
        <img src={starB} alt="img" />
      </div>
      <Timetables favLines={favLines} />
      <div className="favs-container">
        <FavLines
          favLines={favLines}
          allLines={allLines}
          loading={loadingLines}
        />
        <FavStops
          favStops={favStops}
          allStops={allStops}
          loading={loadingStops}
        />
        <div data-testid="snackbar" id="snackbar">{t("element_added")}</div>
        <div data-testid="snackbar-error" id="snackbar-error">{t("error")}</div>
      </div>
    </div>
  );
});

export default Favorites;
